export const communicationMethodOptions = [
  {
    label: 'Patient Portal',
    value: 'Patient Portal'
  },
  {
    label: 'Phone Call',
    value: 'Phone Call'
  }
];

export const contactOutcomeOptions = [
  {
    label: 'Reached',
    value: 'Reached'
  },
  {
    label: 'Left Message',
    value: 'Left Message'
  },
  {
    label: 'Scheduled Callback',
    value: 'Scheduled Callback'
  },
  {
    label: 'Unable to Reach',
    value: 'Unable to Reach'
  }
];

export const patientFallback = {
  patient: 'Willow, Gwen Marry',
  mrNumber: '2318634',
  createdBy: 'Jennifer Lee',
  createdDate: '5/16/2026 at 5:30 PM',
  issueNote:
    'Patient requesting refill for hypertension medication. Current prescription expires today.',
  providerName: 'Dr. Alice William',
  providerResponseDate: '5/16/2026 at 7:30 PM',
  providerResponse:
    'Approved for refill. Same dosage as previous. Can send to pharmacy directly.'
};